module.exports = __webpack_public_path__ + "static/media/event.fa4f7d4c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/event.png
// module id = 227
// module chunks = 0